import type { NavigateFunction } from 'react-router';
import { useNavigate, useParams } from 'react-router';

import { getShipmentScopeFromSlug, getShipmentScopeUrl } from '../routingHelpers';
import type { ShipmentScope, UseShipmentListScopeResult } from '../types';

const useShipmentListScope = (): UseShipmentListScopeResult => {
  const navigate: NavigateFunction = useNavigate();
  const { scope: scopeSlug } = useParams<{ scope?: string }>();
  const activeScope: ShipmentScope = getShipmentScopeFromSlug(scopeSlug);

  const setActiveScope = (scope: ShipmentScope): void => {
    navigate(getShipmentScopeUrl(scope));
  };

  return { activeScope, setActiveScope };
};

export default useShipmentListScope;
